import React from "react"
import * as React_ from "elm-ts/lib/React"
import * as Icon from "./Icon"

export default function <msg>({
  isOpen,
  body,
  closeMsg,
  containerStyles,
}: {
  isOpen: boolean
  containerStyles: string
  body: React_.Html<msg>
  closeMsg: msg
}): React_.Html<msg> {
  return dispatch => (
    <Modal
      isOpen={isOpen}
      closeMsg={() => dispatch(closeMsg)}
      body={body(dispatch)}
      containerStyles={containerStyles}
    />
  )
}

const Modal = ({
  isOpen,
  body,
  containerStyles,
  closeMsg,
}: {
  isOpen: boolean
  body: React.ReactNode
  containerStyles: string
  closeMsg: () => void
}): JSX.Element => {
  const bodyRef = React.useRef<HTMLDivElement>(null)

  const handleEscKey = (key: React.KeyboardEvent<HTMLDivElement>["key"]) => {
    if (key === "Escape") {
      closeMsg()
    }
  }

  React.useEffect(() => {
    window.addEventListener("keydown", e => handleEscKey(e.key))

    return () => {
      window.removeEventListener("keydown", e => handleEscKey(e.key))
    }
  }, [])

  React.useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "unset"
    return () => {
      document.body.style.overflow = "unset"
    }
  }, [isOpen])

  return isOpen ? (
    <div
      className="w-screen h-screen fixed bg-slate inset-0 z-40 bg-opacity-20 overflow-hidden transition-opacity"
      onClick={e => {
        // Only close if clicking directly on the backdrop, not its children
        if (e.currentTarget === e.target) {
          closeMsg()
        }
      }}
    >
      <div className="relative w-[calc(100vw-48px)] md:w-[80vw] max-w-[800px] translate-x-1/2 max-h-[90vh] overflow-y-auto mt-10 self-center-x">
        <button
          className="button-icon absolute top-4 right-4 z-20"
          data-cy="modal-close-btn"
          onClick={closeMsg}
          autoFocus
        >
          <Icon.Close />
        </button>
        <div
          ref={bodyRef}
          className={containerStyles}
          role="dialog"
          aria-modal={true}
        >
          {body}
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}
